import React from 'react';
import { Translate } from 'react-localize-redux';

class QuickAddressReportRelations extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? null : this.renderContent(this.props.data));
    }

    renderContent(data) {
        return (
            <div>
                <div style={{ paddingBottom: "0.5em" }}>
                    <span className="bold"><Translate id="Report.Quick.Common.Count" />:</span>
                    {" "}
                    <span>{data.count}</span>
                </div>
                <table className="table table-report-section-3">
                    <thead>
                        <tr>
                            <th><Translate id="Report.QuickAddress.Relations.Id" /></th>
                            <th><Translate id="Report.QuickAddress.Relations.Name" /></th>
                            <th><Translate id="Report.Common.From" /></th>
                            <th><Translate id="Report.Common.To" /></th>
                        </tr>
                    </thead>
                        <tbody>
                            {data.relatedEntities.map(e =>
                                <tr className={e.isActive ? undefined : "italic-text"}>
                                    <td>{e.isCompany ? e.companyId : e.birthDateFormated}</td>
                                    <td>{e.name}</td>
                                    <td>{e.startDateFormated}</td>
                                    <td>{e.endDateFormated}</td>
                                </tr>)}
                        </tbody>
                </table>
            </div>
        )
    }
}

export default QuickAddressReportRelations;